import React, { useEffect, useContext, useState, useRef } from 'react';
import { AppContext } from '../../../context/Context';
import { SocketContext } from '../../../context/SocketContext';
import { useTranslation } from 'react-i18next';
import { Box, Typography, Button } from '@mui/material';
import {
  Cancel as CancelIcon,
  AccountBalanceWallet as AccountBalanceWalletIcon,
  CreditCard as CreditCardIcon,
  CheckCircle as CheckCircleIcon,
} from '@mui/icons-material/';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import useId from 'react-use-uuid';
import Logo from '../../../assets/img/clubhouse_logo.png';

const glassBg = 'rgba(255,255,255,0.06)';
const glassBorder = '1px solid rgba(255,255,255,0.14)';
const accent = '#FFC727';

function ModalPayment() {
  const { t } = useTranslation();
  var uuidTrans = useId();

  const {
    kioskPaymentAccountEnabled,
    kioskPaymentCardEnabled,
    updateTicketSelectedKioskWG,
    ticketSelectedKioskOK,
    updateTicketSelectedKioskOK,
    ticketParamsSelectedKioskOK,
    updateTicketParamsSelectedKioskOK,
    updateUserLimits,
    updateIsMonthlyLimitSurpassed,
    updateIsDailyLimitSurpassed,
    updateIsLimitSurpassed,
    updateShowIsLimitSurpassed,
    updateShowModalLimitSurpassedKiosk,
    printReceiptKiosk,
    updateTransactionsKiosk,
    updateShowModalPaymentKiosk,
    logoutKiosk,
    logoutUser,
    hall,
    userInfo,
    transactionsKiosk,
    updateIsLoadingScreen,
    parentInfo,
    operator,
    session,
    currentUser,
    printer,
    cardID,
    OKBingoID,
    WGBingoID,

    receiptToPrint,
    updateReceiptToPrint,
  } = useContext(AppContext);
  const { socket } = useContext(SocketContext);
  const navigate = useNavigate();

  const [isWaitingForCard, setIsWaitingForCard] = React.useState(
    !kioskPaymentAccountEnabled
  );
  const [isPaymentSuccessful, setIsPaymentSuccessful] = React.useState(false);
  const [isPaymentError, setIsPaymentError] = React.useState(false);
  const [isCancelingPayment, setIsCancelingPayment] = React.useState(false); //Control the null response from the terminal when canceling a transaction
  const isCancelingPaymentRef = useRef(isCancelingPayment);
  useEffect(() => {
    isCancelingPaymentRef.current = isCancelingPayment;
  }, [isCancelingPayment]);
  const pendingPaymentMethodRef = useRef(null);

  const [isOK, setIsOK] = React.useState(false);
  const [showPinConfirm, setShowPinConfirm] = React.useState(false);
  const [pinCode, setPinCode] = React.useState('');

  useEffect(() => {
    if (!showPinConfirm || pinCode.length !== 4) return;
    if (pinCode === userInfoRef.current?.PIN2) {
      setShowPinConfirm(false);
      setPinCode('');
      updateIsLoadingScreen(true);
      requestPaymentLimitCheck('saldo');
    } else {
      toast.error(t('kiosk.infoTicketErrorPinMessage'));
      setPinCode('');
    }
  }, [pinCode, showPinConfirm]);

  const handlePinKeypad = (key) => {
    if (key === 'back') { setPinCode((p) => p.slice(0, -1)); return; }
    if (key === 'clear') { setPinCode(''); return; }
    if (pinCode.length >= 4) return;
    setPinCode((p) => p + key);
  };
  const [isProcessPaymentReady, setIsProcessPaymentReady] =
    React.useState(false);

  useEffect(() => {
    if (isProcessPaymentReady && !isOK) {
      updateTransactionsKiosk(false);
      logoutUser();
      logoutKiosk();
      updateShowModalPaymentKiosk(false);

      const hallToUse = hallRef.current || hall || 'Roulingo';
      navigate(`/login-kiosk?hall=${encodeURIComponent(hallToUse)}`, {
        replace: true,
      });
    }
  }, [isProcessPaymentReady, isOK]);

  const kioskPaymentAccountEnabledRef = useRef(kioskPaymentAccountEnabled);
  useEffect(() => {
    kioskPaymentAccountEnabledRef.current = kioskPaymentAccountEnabled;
    if (!kioskPaymentAccountEnabled) {
      requestPaymentLimitCheck('card');
    }
  }, [kioskPaymentAccountEnabled]);

  const kioskPaymentCardEnabledRef = useRef(kioskPaymentCardEnabled);
  useEffect(() => {
    kioskPaymentCardEnabledRef.current = kioskPaymentCardEnabled;
  }, [kioskPaymentCardEnabled]);

  const [okTicketID, setOkTicketID] = useState(false);
  const okTicketIDRef = useRef(okTicketID);
  useEffect(() => {
    okTicketIDRef.current = okTicketID;
  }, [okTicketID]);

  const cardIDRef = useRef(cardID);
  useEffect(() => {
    cardIDRef.current = cardID;
  }, [cardID]);

  const OKBingoIDRef = useRef(OKBingoID);
  useEffect(() => {
    OKBingoIDRef.current = OKBingoID;
  }, [OKBingoID]);

  const WGBingoIDRef = useRef(WGBingoID);
  useEffect(() => {
    WGBingoIDRef.current = WGBingoID;
  }, [WGBingoID]);

  const receiptToPrintRef = useRef(receiptToPrint);
  useEffect(() => {
    receiptToPrintRef.current = receiptToPrint;
  }, [receiptToPrint]);

  const printReceiptKioskRef = useRef(printReceiptKiosk);
  useEffect(() => {
    printReceiptKioskRef.current = printReceiptKiosk;
  }, [printReceiptKiosk]);

  const hallRef = useRef(hall);
  useEffect(() => {
    hallRef.current = hall;
  }, [hall]);

  const userInfoRef = useRef(userInfo);
  useEffect(() => {
    userInfoRef.current = userInfo;
  }, [userInfo]);

  const parentInfoRef = useRef(parentInfo);
  useEffect(() => {
    parentInfoRef.current = parentInfo;
  }, [parentInfo]);

  const operatorRef = useRef(operator);
  useEffect(() => {
    operatorRef.current = operator;
  }, [operator]);

  const sessionRef = useRef(session);
  useEffect(() => {
    sessionRef.current = session;
  }, [session]);

  const transactionsKioskRef = useRef(transactionsKiosk);
  useEffect(() => {
    transactionsKioskRef.current = transactionsKiosk;
    setTotal(
      transactionsKiosk.reduce((acc, obj) => acc + parseInt(obj.amount), 0)
    );

    setIsOK(transactionsKiosk.some((t) => t.provider === 'OK D.'));
  }, [transactionsKiosk]);

  const currentUserRef = useRef(currentUser);
  useEffect(() => {
    currentUserRef.current = currentUser;
  }, [currentUser]);

  const printerRef = useRef(printer);
  useEffect(() => {
    printerRef.current = printer;
  }, [printer]);

  const [total, setTotal] = React.useState(0);

  const toNumber = (value) => {
    const parsedValue = Number(value);
    return Number.isFinite(parsedValue) ? parsedValue : 0;
  };

  // Papir (paper) tickets must not count against the player's spending limit,
  // even though they are still part of the amount the player pays (total).
  const isPapirTransaction = (transaction) => {
    const haystack = (
      transaction?.description ||
      transaction?.name ||
      ''
    ).toLowerCase();
    return haystack.includes('papir');
  };

  const executePaymentWithSaldo = () => {
    var dataToSend = {
      bingoName: hallRef.current,
      playerID: !parentInfoRef.current
        ? userInfoRef.current.id
        : parentInfoRef.current.id,
      amount: parseInt(total),
      usePrinter: false,
      useSMS: false,
      printBarcode: false,
      qrMessage: false,
      session: sessionRef.current,
      action: 'cashout',
      userInfo: !parentInfoRef.current
        ? userInfoRef.current
        : parentInfoRef.current,
      cashoutType: 'cash_from_wallet',
      printer: printerRef.current,
      isKiosk: true,
      dataToSaveTransaction: {
        operator: operatorRef.current,
        bingoName: hallRef.current,
        sessionID: sessionRef.current,
        provider: 'CH',
        description: 'Betal med spillerkonto',
        amount: parseInt(total),
        user7Pincode: !parentInfoRef.current
          ? currentUser
          : parentInfoRef.current['7 digit PIN'],
        userInfo: !parentInfoRef.current
          ? userInfoRef.current
          : parentInfoRef.current,
        action: 'newTransaction',
        ticketID: userInfoRef.current.id,
        ticketUsername: userInfoRef.current.username,
        ticket7Pincode: currentUserRef.current,
      },
    };

    socket.emit('cashoutPayment', dataToSend);
    updateIsLoadingScreen(true);
  };

  const executePaymentWithCard = () => {
    if (cardIDRef.current !== '') {
      var data = {
        amount: total,
        operator: operatorRef.current,
        bingoName: hallRef.current,
        sessionID: sessionRef.current,
        user7Pincode: userInfoRef.current['7 digit PIN'],
        userInfo: userInfoRef.current,
        uuid: uuidTrans,
        cardID: cardIDRef.current,
        action: 'netsTransaction',
        platform: 'kiosk',

        dataToSaveTransaction: {
          operator: operatorRef.current,
          bingoName: hallRef.current,
          sessionID: sessionRef.current,
          provider: '',
          description: 'Betal med kort',
          amount: parseInt(total),
          user7Pincode:
            userInfoRef.current?.username !== 'Gjest'
              ? currentUserRef.current
              : 'Gjest',
          userInfo: userInfoRef.current,
          action: 'newTransaction',
          ticketID:
            userInfoRef.current?.username !== 'Gjest'
              ? userInfoRef.current.id
              : 0,
          ticketUsername:
            userInfoRef.current?.username !== 'Gjest'
              ? userInfoRef.current.username
              : 'Gjest',
          ticket7Pincode:
            userInfoRef.current?.username !== 'Gjest'
              ? currentUserRef.current
              : 'Gjest',
        },
      };
      socket.emit('netsTransaction', data);
      setIsWaitingForCard(true);
    } else {
      setIsPaymentSuccessful(true);
      var dataToSend = {
        operator: operatorRef.current,
        bingoName: hallRef.current,
        sessionID: sessionRef.current,
        provider: '',
        description: 'Betal med kort',
        amount: total,
        cardID: cardIDRef.current,
        action: 'newTransaction',
        ticketID: userInfoRef.current.id ? userInfoRef.current.id : '',
        ticketUsername: userInfoRef.current.username
          ? userInfoRef.current.username
          : '',
        ticket7Pincode: currentUserRef.current,
        user7Pincode: !parentInfoRef.current
          ? userInfoRef.current['7 digit PIN']
          : parentInfoRef.current['7 digit PIN'],
        userInfo: !parentInfoRef.current
          ? userInfoRef.current
          : parentInfoRef.current,
        netsTicket: receiptToPrintRef.current,
      };

      socket.emit('newTransaction', dataToSend);
    }
  };

  const requestPaymentLimitCheck = (method) => {
    pendingPaymentMethodRef.current = method;
    socket.emit('checkLimitStatus', {
      userInfo: !parentInfoRef.current
        ? userInfoRef.current
        : parentInfoRef.current,
      bingoName: hallRef.current,
    });
  };

  useEffect(() => {
    const handleProcessBatchKiosk = (data) => {
      setIsProcessPaymentReady(true);
    };
    const handleCashoutPayment = (data) => {
      if (!data) {
        updateIsLoadingScreen(false);
        toast.error(t('error.error'));
        return;
      }

      updateIsLoadingScreen(false);
      processBatchKiosk();
    };

    const handleNetsTransaction = (data) => {
      console.log(
        'Received netsTransaction data:',
        data,
        isCancelingPaymentRef.current
      );
      updateIsLoadingScreen(false);

      if (!data && isCancelingPaymentRef.current) {
        setIsCancelingPayment(false);
        return;
      }

      if (!data) {
        console.log('Payment error: No data received from netsTransaction');
        setIsPaymentError(true);
        setIsWaitingForCard(false);
        return;
      }

      setIsPaymentSuccessful(true);
      setIsWaitingForCard(false);

      setTimeout(() => {
        processBatchKiosk();
      }, 2000);
    };

    const handleNewTransaction = (data) => {
      console.log('Received newTransaction data:', data);
      if (!data) {
        setIsPaymentError(true);
        setIsWaitingForCard(false);
        return;
      }

      setIsPaymentSuccessful(true);
      setIsWaitingForCard(false);

      setTimeout(() => {
        processBatchKiosk();
      }, 2000);
    };

    const handleCheckLimitStatus = (data) => {
      if (!data || !data.limits) {
        return;
      }
      if (data.bingoName !== hallRef.current) {
        return;
      }

      if (data.isTicket) {
        return;
      }

      updateUserLimits(data.limits);

      // Only non-papir transactions count toward the spending limit.
      const limitTotal = (transactionsKioskRef.current || []).reduce(
        (acc, obj) =>
          isPapirTransaction(obj) ? acc : acc + toNumber(obj.amount),
        0
      );

      const dailyWithCurrentTotal =
        toNumber(data.limits?.daily?.cashIn) -
        (toNumber(data.limits?.daily?.cashOut) +
          toNumber(data.limits?.daily?.rollover)) +
        limitTotal;
      const monthlyWithCurrentTotal =
        toNumber(data.limits?.monthly?.totalSpent) -
        toNumber(data.limits?.monthly?.rollover) +
        limitTotal;

      const dailyLimitSurpassed =
        dailyWithCurrentTotal > toNumber(data.limits?.daily?.limit);
      const monthlyLimitSurpassed =
        monthlyWithCurrentTotal > toNumber(data.limits?.monthly?.limit);

      if (dailyLimitSurpassed || monthlyLimitSurpassed) {
        pendingPaymentMethodRef.current = null;
        updateShowModalLimitSurpassedKiosk(true);
        return;
      }

      if (pendingPaymentMethodRef.current === 'saldo') {
        pendingPaymentMethodRef.current = null;
        executePaymentWithSaldo();
        return;
      }

      if (pendingPaymentMethodRef.current === 'card') {
        pendingPaymentMethodRef.current = null;
        executePaymentWithCard();
        return;
      }

      if (data.isMonthly) {
        updateIsMonthlyLimitSurpassed(true);
        updateIsLimitSurpassed(true);
        updateShowIsLimitSurpassed(true);
        return;
      }
      if (data.isDaily) {
        updateIsDailyLimitSurpassed(true);
        updateIsLimitSurpassed(true);
        updateShowIsLimitSurpassed(true);
        return;
      }
    };

    const handleCashinOK = (data) => {
      setOkTicketID(data.ticketID);
    };

    const handleBroadcastCashinOK = (data) => {
      if (data.errorNumber !== '') {
        toast.error(data.errorDescription);
        updateIsLoadingScreen(false);

        return;
      }

      updateTicketSelectedKioskOK(data.ticketNumber);
      updateTicketParamsSelectedKioskOK(data);

      if (data.ticketID === okTicketIDRef.current) {
        socket.emit('registerTransactionCashinOK', {
          operator: operatorRef.current,
          bingoName: hallRef.current,
          sessionID: sessionRef.current,
          userInfo: parentInfoRef.current
            ? parentInfoRef.current
            : userInfoRef.current,
          amount: parseInt(total),
          provider: 'OK D.',
          description: 'Ny Billett',
          okID: data.ticketNumber,
          action: 'registerTransactionCashinOK',
          printer: printerRef.current,
          parameter: data,
          OKBingoID: OKBingoIDRef.current,
        });
      }
    };

    const handleRegisterTransactionCashinOK = (data) => {
      setIsOK(false);
    };

    const handleRefillOK = (data) => {
      setOkTicketID(data.ticketID);
    };

    const handleBroadcastRefillOK = (data) => {
      if (data.errorNumber !== '') {
        toast.error(data.errorDescription);
        updateIsLoadingScreen(false);
        return;
      }

      updateTicketSelectedKioskOK(data.ticketNumber);
      updateTicketParamsSelectedKioskOK(data);

      if (data.ticketID === okTicketIDRef.current) {
        socket.emit('registerTransactionRefillOK', {
          operator: operatorRef.current,
          bingoName: hallRef.current,
          sessionID: sessionRef.current,
          userInfo: parentInfoRef.current
            ? parentInfoRef.current
            : userInfoRef.current,
          amount: parseInt(total),
          provider: 'OK D.',
          description: 'Fylle på',
          okID: data.ticketNumber,
          action: 'registerTransactionRefillOK',
          printer: printerRef.current,
          parameter: data,
          OKBingoID: OKBingoIDRef.current,
        });
      }
    };

    const handleRegisterTransactionRefillOK = (data) => {
      setIsOK(false);
    };

    socket.on('processBatchKiosk', handleProcessBatchKiosk);
    socket.on('checkLimitStatus', handleCheckLimitStatus);

    socket.on('cashoutPayment', handleCashoutPayment);
    socket.on('netsTransaction', handleNetsTransaction);
    socket.on('newTransaction', handleNewTransaction);

    socket.on('cashinOK', handleCashinOK);
    socket.on('broadcastCashinOK', handleBroadcastCashinOK);
    socket.on('registerTransactionCashinOK', handleRegisterTransactionCashinOK);

    socket.on('refillOK', handleRefillOK);
    socket.on('broadcastRefillOK', handleBroadcastRefillOK);
    socket.on('registerTransactionRefillOK', handleRegisterTransactionRefillOK);

    return () => {
      socket.off('processBatchKiosk', handleProcessBatchKiosk);
      socket.off('checkLimitStatus', handleCheckLimitStatus);

      socket.off('cashoutPayment', handleCashoutPayment);
      socket.off('netsTransaction', handleNetsTransaction);
      socket.off('newTransaction', handleNewTransaction);

      socket.off('cashinOK', handleCashinOK);
      socket.off('broadcastCashinOK', handleBroadcastCashinOK);
      socket.off(
        'registerTransactionCashinOK',
        handleRegisterTransactionCashinOK
      );

      socket.off('refillOK', handleRefillOK);
      socket.off('broadcastRefillOK', handleBroadcastRefillOK);
      socket.off(
        'registerTransactionRefillOK',
        handleRegisterTransactionRefillOK
      );
    };
  }, [socket, total]);

  const walletBalance = Number(userInfoRef.current?.balances?.wallet || 0);
  const canPayWithWallet =
    userInfoRef.current?.username !== 'Gjest' && walletBalance >= total;

  const paymentButtonStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
  };

  const paymentInfoStyle = {
    fontSize: '24px',
    margin: '6px 0',
  };

  const handleCancel = () => {
    pendingPaymentMethodRef.current = null;
    updateShowModalPaymentKiosk(false);
  };

  const handlePaymentWithSaldo = () => {
    setPinCode('');
    setShowPinConfirm(true);
  };

  const handlePaymentWithCard = () => {
    //This line blocks the user to be able to cancel the transaction
    //updateIsLoadingScreen(true);

    requestPaymentLimitCheck('card');
  };

  const handleCancelWaitingForCard = () => {
    setIsCancelingPayment(true);
    updateIsLoadingScreen(true);
    var data = {
      action: 'cancelTransaction',
      amount: parseInt(total),
      operator: operatorRef.current,
      bingoName: hallRef.current,
      sessionID: sessionRef.current,
      user7Pincode: currentUserRef.current,
      userInfo: userInfoRef.current,
      uuid: uuidTrans,
      platform: 'kiosk',
    };
    socket.emit('cancelTransaction', data);

    /*
    if (!kioskPaymentAccountEnabledRef.current) {
      updateShowModalPaymentKiosk(false);
      return;
    }
      */

    setTimeout(() => {
      setIsWaitingForCard(false);
      setIsPaymentError(false);
      setIsPaymentSuccessful(false);
      updateIsLoadingScreen(false);
    }, 800);
    if (!kioskPaymentAccountEnabledRef.current) {
      pendingPaymentMethodRef.current = null;
      updateShowModalPaymentKiosk(false);
    }
  };

  const handlePaymentError = () => {
    updateIsLoadingScreen(false);
    setIsWaitingForCard(false);
    setIsPaymentSuccessful(false);
    setIsPaymentError(false);
  };

  const processBatchKiosk = () => {
    setIsProcessPaymentReady(false);
    updateIsLoadingScreen(true);
    socket.emit('processBatchKiosk', {
      transactionsList: transactionsKioskRef.current,
      operator: operatorRef.current,
      bingoName: hallRef.current,
      session: sessionRef.current,
      sessionID: sessionRef.current,
      userInfo: parentInfoRef.current
        ? parentInfoRef.current
        : userInfoRef.current,
      printer: printerRef.current,
      OKBingoID: OKBingoIDRef.current,
      bingoID: WGBingoIDRef.current,
      user7Pincode: !parentInfoRef.current
        ? currentUserRef.current
        : parentInfoRef.current['7 digit PIN'],
      userInfo: !parentInfoRef.current
        ? userInfoRef.current
        : parentInfoRef.current,
      isPrintedByCH: true,
      qrMessage: false,
      printBarcode: false,
      useSMS: false,
      playerID: userInfoRef.current.id,
      userID:
        parentInfoRef.current && parentInfoRef.current.id
          ? parentInfoRef.current.id
          : userInfoRef.current && userInfoRef.current.id
            ? userInfoRef.current.id
            : 0,
      username: parentInfoRef.current
        ? parentInfoRef.current.username
        : userInfoRef.current.username,
      isAnon: userInfoRef.current.username === 'Gjest' ? true : false,
      ticketID: userInfoRef.current.id,
      ticketUsername: userInfoRef.current.username,
      ticket7Pincode: userInfoRef.current['7 digit PIN'],
      isPrintedByCH: true,
      qrMessage: false,
      printBarcode: false,
      useSMS: false,

      userNeedsReceipt: printReceiptKioskRef.current,
    });
  };

  const overlayStyle = {
    position: 'fixed',
    inset: 0,
    zIndex: 9999,
    background: 'rgba(3,6,18,0.88)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '24px 16px',
  };

  const dialogStyle = {
    width: 'min(760px, 96vw)',
    borderRadius: '24px',
    overflow: 'hidden',
    border: '1px solid rgba(255,255,255,0.12)',
    boxShadow: '0 30px 90px rgba(0,0,0,0.65)',
    backdropFilter: 'blur(14px)',
    WebkitBackdropFilter: 'blur(14px)',
    background:
      'linear-gradient(135deg, rgba(18,26,55,0.98), rgba(10,14,28,0.98))',
    padding: '40px 48px',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  };

  const btnGold = {
    bgcolor: '#FFC727',
    color: '#000',
    fontWeight: 800,
    fontSize: '18px',
    height: '72px',
    px: 4,
    boxShadow: '0 4px 18px rgba(255,199,39,0.35)',
    '&:hover': {
      bgcolor: '#e6b320',
      boxShadow: '0 6px 22px rgba(255,199,39,0.5)',
    },
    '&:disabled': {
      bgcolor: 'rgba(255,255,255,0.12)',
      color: 'rgba(255,255,255,0.3)',
      boxShadow: 'none',
    },
  };

  const btnGlass = {
    bgcolor: 'rgba(255,255,255,0.08)',
    color: 'rgba(255,255,255,0.75)',
    border: '1px solid rgba(255,255,255,0.14)',
    fontWeight: 700,
    fontSize: '18px',
    height: '72px',
    px: 4,
    '&:hover': { bgcolor: 'rgba(255,255,255,0.14)' },
  };

  return (
    <>
      <div id="react-confirm-alert">
        <div style={overlayStyle}>
          <div
            style={{
              ...dialogStyle,
              width: showPinConfirm ? 'min(1100px, 94vw)' : '900px',
              display: 'flex',
              justifyContent: 'center',
              alignContent: 'center',
            }}
          >
            {/* PIN CONFIRMATION */}
            {showPinConfirm && (
              <Box sx={{ display: 'flex', gap: '20px', minHeight: 0 }}>

                {/* LEFT: dots + keypad */}
                <Box sx={{ flex: '0 0 360px', display: 'flex', flexDirection: 'column', gap: '20px' }}>
                  {/* 4-dot display */}
                  <Box sx={{
                    borderRadius: '18px', border: glassBorder,
                    background: glassBg, p: '22px',
                    display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '24px',
                  }}>
                    {[0, 1, 2, 3].map((i) => (
                      <Box key={i} sx={{
                        width: 28, height: 28, borderRadius: '50%',
                        border: `2.5px solid ${pinCode.length > i ? accent : 'rgba(255,255,255,0.25)'}`,
                        background: pinCode.length > i ? accent : 'transparent',
                        transition: 'all 0.15s ease',
                        boxShadow: pinCode.length > i ? `0 0 14px ${accent}88` : 'none',
                      }} />
                    ))}
                  </Box>

                  {/* Keypad */}
                  <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '12px', flex: 1 }}>
                    {['1','2','3','4','5','6','7','8','9','back','0','clear'].map((key) => (
                      <Button
                        key={key}
                        variant="contained"
                        onClick={() => handlePinKeypad(key)}
                        sx={{
                          height: 110, borderRadius: '16px',
                          fontSize: key === 'back' || key === 'clear' ? 22 : 34,
                          fontWeight: 700, textTransform: 'none', color: 'white',
                          border: glassBorder,
                          background: key === 'clear'
                            ? 'rgba(255,255,255,0.08)'
                            : 'linear-gradient(180deg, rgba(255,255,255,0.12), rgba(255,255,255,0.06))',
                          boxShadow: '0 6px 16px rgba(0,0,0,0.3)',
                          '&:hover': {
                            background: key === 'clear'
                              ? 'rgba(255,255,255,0.14)'
                              : 'linear-gradient(180deg, rgba(255,255,255,0.18), rgba(255,255,255,0.10))',
                            transform: 'translateY(-2px)',
                          },
                          '&:active': { transform: 'translateY(0)' },
                        }}
                      >
                        {key === 'back' ? '⌫' : key === 'clear' ? (t('kiosk.clear') || 'Clear') : key}
                      </Button>
                    ))}
                  </Box>
                </Box>

                {/* RIGHT: info + cancel */}
                <Box sx={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', gap: '20px' }}>
                  {/* Info card */}
                  <Box sx={{
                    flex: 1, borderRadius: '18px', border: glassBorder,
                    background: glassBg, p: '28px',
                    display: 'flex', flexDirection: 'column', gap: '18px',
                  }}>
                    <Box sx={{ display: 'flex', justifyContent: 'center', mb: 1 }}>
                      <Box component="img" src={Logo} alt="Clubhouse"
                        sx={{ maxHeight: 70, objectFit: 'contain' }} />
                    </Box>

                    <Typography sx={{ color: 'white', fontWeight: 700, fontSize: 26 }}>
                      {t('kiosk.confirmPinTitle')}
                    </Typography>

                    <Typography sx={{ color: 'rgba(255,255,255,0.65)', fontSize: 22 }}>
                      {t('kiosk.confirmPinMessage2')}
                    </Typography>

                    <Box sx={{ mt: 'auto', borderRadius: '12px', border: glassBorder, background: 'rgba(255,199,39,0.08)', p: '16px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                      <Typography sx={{ color: 'rgba(255,255,255,0.65)', fontSize: 20 }}>
                        {t('kiosk.total')}
                      </Typography>
                      <Typography sx={{ color: accent, fontWeight: 900, fontSize: 34, lineHeight: 1 }}>
                        {total} kr
                      </Typography>
                      <Typography sx={{ color: 'rgba(255,255,255,0.45)', fontSize: 18 }}>
                        {t('kiosk.currentSaldo')}: {walletBalance} kr
                      </Typography>
                    </Box>
                  </Box>

                  {/* Cancel */}
                  <Button
                    fullWidth variant="contained"
                    startIcon={<CancelIcon sx={{ fontSize: 28 }} />}
                    onClick={() => { setShowPinConfirm(false); setPinCode(''); }}
                    sx={{
                      height: 88, borderRadius: '16px',
                      bgcolor: 'rgba(255,255,255,0.08)', color: 'rgba(255,255,255,0.75)',
                      fontWeight: 800, fontSize: 22, textTransform: 'uppercase',
                      border: glassBorder, boxShadow: 'none', flexShrink: 0,
                      '&:hover': { bgcolor: 'rgba(255,255,255,0.14)', transform: 'translateY(-2px)', color: 'white' },
                      '&:active': { transform: 'translateY(0)' },
                    }}
                  >
                    {t('sales.cancel')}
                  </Button>
                </Box>

              </Box>
            )}

            {/* INITIAL STATE — show payment options */}
            {!showPinConfirm && !isWaitingForCard && !isPaymentError && !isPaymentSuccessful && (
              <>
                <Typography
                  sx={{ color: 'white', fontSize: '28px', fontWeight: 900 }}
                >
                  {t('kiosk.confirmPaymentTitle')}
                </Typography>
                <Typography
                  sx={{ color: 'rgba(255,255,255,0.75)', fontSize: '25px' }}
                >
                  {t('kiosk.confirmPaymentMessage')}
                </Typography>
                <Typography
                  sx={{
                    color: 'white',
                    fontSize: '24px',
                    fontWeight: 800,
                    mt: 1,
                  }}
                >
                  {t('kiosk.total') + ': ' + total + ' kr'}
                </Typography>
                {userInfoRef.current?.username !== 'Gjest' &&
                  kioskPaymentAccountEnabledRef.current && (
                    <Typography
                      sx={{
                        color: 'rgba(255,255,255,0.75)',
                        fontSize: '25px',
                      }}
                    >
                      {t('kiosk.currentSaldo') + ': ' + walletBalance + ' kr'}
                    </Typography>
                  )}
                {userInfoRef.current?.username !== 'Gjest' &&
                  !canPayWithWallet && (
                    <Typography
                      sx={{
                        color: 'rgba(255,255,255,0.5)',
                        fontSize: '25px',
                      }}
                    >
                      {t('kiosk.paymentNotAvailable')}
                    </Typography>
                  )}
                <Box sx={{ display: 'flex', gap: 2, mt: 3, flexWrap: 'wrap' }}>
                  {kioskPaymentCardEnabledRef.current && (
                    <Button
                      variant="contained"
                      startIcon={<CreditCardIcon />}
                      onClick={handlePaymentWithCard}
                      sx={{
                        height: 88,
                        borderRadius: '16px',
                        bgcolor: accent,
                        color: '#000',
                        fontWeight: 800,
                        fontSize: 22,
                        textTransform: 'uppercase',
                        boxShadow: `0 12px 32px ${accent}66`,
                        '&:hover': {
                          bgcolor: '#FFD54F',
                          transform: 'translateY(-2px)',
                          boxShadow: `0 16px 40px ${accent}88`,
                        },
                        '&:active': { transform: 'translateY(0)' },
                      }}
                    >
                      {t('kiosk.payWithCard')}
                    </Button>
                  )}
                  {kioskPaymentAccountEnabledRef.current && (
                    <Button
                      variant="contained"
                      startIcon={<AccountBalanceWalletIcon />}
                      onClick={handlePaymentWithSaldo}
                      disabled={!canPayWithWallet}
                      sx={{
                        height: 88,
                        borderRadius: '16px',
                        bgcolor: accent,
                        color: '#000',
                        fontWeight: 800,
                        fontSize: 22,
                        textTransform: 'uppercase',
                        boxShadow: `0 12px 32px ${accent}66`,
                        '&:hover': {
                          bgcolor: '#FFD54F',
                          transform: 'translateY(-2px)',
                          boxShadow: `0 16px 40px ${accent}88`,
                        },
                        '&:active': { transform: 'translateY(0)' },
                      }}
                    >
                      {t('kiosk.payWithSaldo')}
                    </Button>
                  )}
                  <Button
                    variant="contained"
                    startIcon={<CancelIcon />}
                    onClick={handleCancel}
                    sx={{
                      height: 88,
                      borderRadius: '16px',
                      bgcolor: 'rgba(255,255,255,0.08)',
                      color: 'rgba(255,255,255,0.75)',
                      fontWeight: 800,
                      fontSize: 22,
                      textTransform: 'uppercase',
                      border: glassBorder,
                      boxShadow: 'none',
                      '&:hover': {
                        bgcolor: 'rgba(255,255,255,0.14)',
                        transform: 'translateY(-2px)',
                        color: 'white',
                      },
                      '&:active': { transform: 'translateY(0)' },
                    }}
                  >
                    {t('sales.cancel')}
                  </Button>
                </Box>
              </>
            )}

            {/* WAITING FOR CARD */}
            {!showPinConfirm && isWaitingForCard && !isPaymentError && !isPaymentSuccessful && (
              <>
                <Typography
                  sx={{ color: 'white', fontSize: '28px', fontWeight: 900 }}
                >
                  {t('kiosk.confirmPaymentTitle')}
                </Typography>
                <Typography
                  sx={{ color: 'rgba(255,255,255,0.75)', fontSize: '25px' }}
                >
                  {t('kiosk.waitingForCard')}
                </Typography>
                <Box sx={{ display: 'flex', gap: 2, mt: 3 }}>
                  <Button
                    variant="contained"
                    startIcon={<CancelIcon />}
                    onClick={handleCancelWaitingForCard}
                    sx={btnGlass}
                  >
                    {t('sales.cancel')}
                  </Button>
                </Box>
              </>
            )}

            {/* PAYMENT ERROR */}
            {!showPinConfirm && !isWaitingForCard && isPaymentError && !isPaymentSuccessful && (
              <>
                <Typography
                  sx={{ color: 'white', fontSize: '28px', fontWeight: 900 }}
                >
                  {t('kiosk.errorPaymentTitle')}
                </Typography>
                <Typography
                  sx={{ color: '#ff6b6b', fontSize: '25px', fontWeight: 700 }}
                >
                  {t('kiosk.errorPaymentMessage')}
                </Typography>
                <Box sx={{ display: 'flex', gap: 2, mt: 3 }}>
                  <Button
                    variant="contained"
                    startIcon={<CheckCircleIcon />}
                    onClick={handlePaymentError}
                    sx={btnGold}
                  >
                    {t('sales.confirm')}
                  </Button>
                </Box>
              </>
            )}

            {/* PAYMENT SUCCESS */}
            {!showPinConfirm && !isWaitingForCard && !isPaymentError && isPaymentSuccessful && (
              <>
                <Typography
                  sx={{ color: 'white', fontSize: '28px', fontWeight: 900 }}
                >
                  {t('kiosk.confirmPaymentTitle')}
                </Typography>
                <Typography
                  sx={{ color: '#4ade80', fontSize: '25px', fontWeight: 700 }}
                >
                  {t('kiosk.paymentSuccess')}
                </Typography>
              </>
            )}
          </div>
        </div>
      </div>

    </>
  );
}

export default ModalPayment;
